import Chart from './ChartComponent';
import BarChart from './BarChartComponent';
import PieChart from './PieChartComponent';
import DifferentiatorChart from './DifferentiatorChartComponent';
import Infos from './InfosComponent';

export default {
  Chart,
  BarChart,
  PieChart,
  DifferentiatorChart,
  Infos
};



// WEBPACK FOOTER //
// ./src/components/aws/costBreakdown/index.js